<template>
  <div class="notice-detail">
    <div class="top-btn">
      <el-button @click="$router.back()" size="small">返回</el-button>
      <el-button type="primary" @click="noticeEditShow = true" size="small" v-show="editShow">编辑</el-button>
      <el-button v-show="notice.createBy == user.id" @click="getReadList" size="small">查看已读列表</el-button>
      <el-button v-show="notice.createBy == user.id && notice.newsType == '重要'" @click="repeatUnRead"
        size="small">重发公告给未读用户</el-button>
      <el-button v-show="notice.createBy !== user.id &&
        notice.newsType == '重要' &&
        notice.readConfirm == 1
        " @click="confirmNewsRead" size="small">确认已读</el-button>
    </div>
    <div class="img-list" v-show="imgList.length != 0">
      <el-carousel :interval="4000" type="card" height="200px">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <el-image fit="contain" class="img" :src="item" :preview-src-list="imgList" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="detail">
      <div class="title">
        {{ notice.title }}
      </div>
      <div class="line"></div>
      <div class="sender">
        <el-image :src="notice.headPortrait" class="sender-head" :preview-src-list="[notice.headPortrait]">
          <div slot="error" class="image-slot" style="
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f5f7fa;
              color: #c0c4cc;
            ">
            <div>无图片</div>
          </div>
        </el-image>
        <div class="right">
          <div class="name">发布人：{{ notice.senderName }}
          </div>
          <div class="createTime" v-if="notice.publicType !== 1">发布时间：{{ notice.publicTime }}</div>
        </div>
      </div>
      <div class="line"></div>
      <!-- <div class="content" v-html="notice.content"></div> -->
      <div class="content" style="white-space: pre-line">
        {{ notice.content }}
      </div>
    </div>
    <noticeEdit v-show="noticeEditShow" :noticeEditShow.sync="noticeEditShow" :notice="notice" @refresh="refresh" />
    <!-- 已入住学生-列表 -->
    <readList :readListShow.sync="readListShow" :readList="readList" v-show="readListShow" />
  </div>
</template>

<script>
import noticeEdit from "./components/notice-edit/notice-edit.vue";
import readList from "./components/read-list/readList.vue";

export default {
  name: "",
  data() {
    return {
      id: "",
      notice: {},
      imgList: [],
      editShow: "", // 是否显示编辑按钮 管理员始终显示 教师根据发布id判断是否显示
      noticeEditShow: false, // 编辑dialog
      readListShow: false, // 已读列表显示
      readList: [], // 已读列表
    };
  },
  components: {
    noticeEdit,
    readList,
  },
  created() {
    // console.log(this.$route.query.id)
    this.id = this.$route.query.id;
    this.getNewsDetail();
  },
  // computed: {
  //   // 计算属性用来格式化日期
  //   formattedDate() {
  //     const date = new Date(this.notice.publicTime);
  //     const year = date.getFullYear();
  //     const month = String(date.getMonth() + 1).padStart(2, '0');
  //     const day = String(date.getDate()).padStart(2, '0');
  //     const hours = String(date.getHours()).padStart(2, '0');
  //     const minutes = String(date.getMinutes()).padStart(2, '0');

  //     return `${year}-${month}-${day} ${hours}:${minutes}`;
  //   },
  // },
  methods: {
    getNewsDetail() {
      this.get(`${this.$url.getNewsDetail}/${this.id}/1`)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.notice = res.data;
            // console.log("公告详情==>", this.notice);
            // console.log("公告详情==>", this.notice.content);
            if (this.notice.imgList && this.notice.imgList.length) {
              this.imgList = this.notice.imgList.split(",");
            }
            this.editShow = this.user.id == this.notice.createBy;
          } else {
            this.$message.error("获取公告详情失败");
          }
        })
        .catch((err) => {
          this.$message.error("获取公告详情失败，请稍后再试");
        });
    },
    // 查看已读列表
    getReadList() {
      this.get(`${this.$url.getNewsRead}?id=${this.id}`)
        .then((res) => {
          // console.log("查看已读列表==>", res);
          if (res.code !== 200) {
            return this.$message.error("获取失败");
          }
          if (!res.data) {
            return this.$message.warning("已读列表为空");
          }
          this.readListShow = true;
          this.readList = res.data;
        })
        .catch((err) => { });
    },
    // 再次推送公告给未读用户
    repeatUnRead() {
      this.get(`${this.$url.pushRecur}?newsId=${this.id}`)
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("发送失败");
          }
          this.$message.success("发送成功");
        })
        .catch((err) => { });
    },
    // 确认已读公告
    confirmNewsRead() {
      this.post(this.$url.confirmNewsRead, {
        newsId: this.id, //公告id
        pushGroup: 1,
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("确认已读失败");
          }
          this.$message.success("确认已读成功");
          this.getNewsDetail();
        })
        .catch((err) => { });
    },
    refresh() {
      this.notice = {};
      this.imgList = [];
      this.getNewsDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./notice-detail.scss";
</style>
